import { NotificationCountResponse, NotificationDetailResponse } from './interfaces';
import { api } from '../configs/axiosConfigs';
import { NotificationFilter, UserInfo } from '@supersports/services';
import { Utils } from '@supersports/styleguide';

export const NotificationApi = {
  getAllNotifications: async (filter: NotificationFilter, userInfo: UserInfo) => {
    const response = await api.get('/api/v1/user/notifications', {
      params: {
        ...filter,
        ...{
          Lang: Utils.convertToLocale(userInfo.Language),
        },
      },
      headers: {
        Authorization: `Bearer ${userInfo.SsToken}`,
      },
    });

    return (response.data as any).Data as NotificationDetailResponse[];
  },

  countNotifications: async (userInfo: UserInfo) => {
    const response = await api.get('/api/v1/user/count-notifications', {
      params: { Lang: Utils.convertToLocale(userInfo.Language) },
      headers: {
        Authorization: `Bearer ${userInfo.SsToken}`,
      },
    });

    return (response.data as any).Data as NotificationCountResponse;
  },
};
